import React from 'react';
import { HereYourPlans } from '@features/onboarding/components/7-finish/HereYourPlans';
import { ExcuseStep } from '@features/onboarding/components/7-finish/components/excuse-step/ExcuseStep';

export const CoverageReassuranceWithExcuse = () => {
  return (
    <div className="flex flex-col h-full">
      <HereYourPlans />
      <div className="mt-0">
        <ExcuseStep hideTitle={true} />
      </div>
    </div>
  );
}; 